import React from "react";
import { Button } from "@mui/material";
import { C, LAYOUT } from "../constants/colors";

const VARIANT_MAP = {
  primary: {
    variant: "contained",
    color: "primary",
    sx: {
      background: C.primary,
      color: "#fff",
      "&:hover": { background: C.primaryDark },
    },
  },
  outline: {
    variant: "outlined",
    color: "primary",
    sx: {
      borderColor: C.borderStrong,
      color: C.text,
      "&:hover": { borderColor: C.primary, background: C.primarySoft, color: C.primaryDark },
    },
  },
  ghost: {
    variant: "text",
    sx: {
      color: C.muted,
      background: "transparent",
      "&:hover": { background: C.surfaceAlt, color: C.text },
    },
  },
};

export default function Btn({ children, onClick, disabled, variant = "primary", small = false, style = {}, title }) {
  const cfg = VARIANT_MAP[variant] || VARIANT_MAP.primary;
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      title={title}
      variant={cfg.variant}
      color={cfg.color}
      size={small ? "small" : "medium"}
      sx={{
        borderRadius: `${LAYOUT.radiusSm}px`,
        fontWeight: 700,
        whiteSpace: "nowrap",
        letterSpacing: "-0.01em",
        ...(cfg.sx || {}),
        ...style,
      }}
    >
      {children}
    </Button>
  );
}
